/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sort_TimeInputs */

const en_sort_time = /** @type {(inputs: Sort_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quickest`)
};

const de_sort_time = /** @type {(inputs: Sort_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellste`)
};

/**
* | output |
* | --- |
* | "Quickest" |
*
* @param {Sort_TimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sort_time = /** @type {((inputs?: Sort_TimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sort_TimeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sort_time(inputs)
	return en_sort_time(inputs)
});